import React from "react";
import { FolderIcon } from "@common/folderIcon";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { useTranslation } from "react-i18next";

import { UseCases } from "@planzone/core";
import { Safeguard } from "@scenes/safeguard";
import { Props } from "./types";
import { ToggleArrow } from "./toggleArrow";
import { StatusList } from "./statusList";
import styles from "./styles.scss";
import classNames from "classnames";

function ProjectStatus({
  project,
  selectStatus,
  isMinimized = false,
  isShortened = false,
}: Props) {
  const { t } = useTranslation();

  return (
    <Safeguard context={{ project }} useCases={[UseCases.editProject]}>
      {({ canEditProject }) => (
        <VisibilityWatcher>
          {(isVisible, show, hide) => (
            <div
              className={classNames(styles.projectStatus, {
                [styles.shortened]: isShortened,
                [styles.minimized]: isMinimized,
              })}
            >
              <div
                className={styles.selectedStatus}
                style={{ borderColor: project.status.color || "#FEA439" }}
                onClick={canEditProject ? (isVisible ? hide : show) : undefined}
              >
                {!isShortened && (
                  <FolderIcon
                    className={styles.folderIcon}
                    style={{ fill: project.status.color || "#FEA439" }}
                    isOpen={false}
                  />
                )}
                <p className={styles.name}>
                  {t(
                    `projectStatuses.${project.status.label}`,
                    project.status.label || "Ouvert",
                  )}
                </p>
                {canEditProject && (
                  <ToggleArrow
                    className={styles.toggleArrow}
                    style={{ fill: project.status.color || "#FEA439" }}
                  />
                )}
              </div>
              {canEditProject && isVisible && (
                <div className={styles.menu}>
                  <StatusList
                    project={project}
                    selectStatus={(status) => {
                      selectStatus(status);
                      hide();
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </VisibilityWatcher>
      )}
    </Safeguard>
  );
}

export { ProjectStatus };
